var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ContentCard',{attrs:{"data-auto-id":"realm-add","title":"Create Realm"}},[_c('div',{staticClass:"py-8 px-4"},[_c('RealmForm',{attrs:{"loading":_vm.loading,"error":_vm.errorMessage},on:{"submit":_vm.createRealm,"cancel":function($event){return _vm.$emit('cancel')}}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }